import Calculator from 'components/Calculator/Calculator';
import './App.scss';

function App() {
   return (
      <div className="app">
         <Calculator />
      </div>
   );
}

export default App;
